import styled from 'styled-components';
import { passwordValidators } from '@utils/validation/passwordRules';

const Container = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 0.5rem 1rem;
	font-size: 0.75rem;
	margin-top: 0.25rem;
	margin-bottom: 0.5rem;
`;

const Requirement = styled.span`
	color: ${props =>
		props.$met
			? props.theme.colors.green || '#28a745'
			: props.theme.colors.textMuted || '#6c757d'};
`;

const requirements = [
	{ key: 'minLength', label: '8+ chars' },
	{ key: 'hasUppercase', label: 'Uppercase' },
	{ key: 'hasLowercase', label: 'Lowercase' },
	{ key: 'hasNumber', label: 'Number' },
	{ key: 'hasSpecialChar', label: 'Special char' },
];

export default function PasswordRequirements({ password = '' }) {
	return (
		<Container>
			{requirements.map(({ key, label }) => {
				const met = passwordValidators[key](password) === true;
				return (
					<Requirement key={key} $met={met}>
						{met ? '✓' : '○'} {label}
					</Requirement>
				);
			})}
		</Container>
	);
}
